import React from 'react';

import PropTypes from 'prop-types';

import { getUserToken } from 'lib/storage';

import companyLogo from '../../../assets/img/company-logo.svg';
import DarkModeSwitch from '../DarkModeSwitch';

import styles from './navbar.module.css';
import { userLogout } from 'services/auth-network';

const NavBar = ({
  toggleNightMode,
  theme
}) => {

  return (
    <>
      <nav className={`${styles.navBarClass}`} style={{ backgroundColor: theme === 'dark' ? '#161c23' : '' }}>
        <img src={companyLogo} alt="company-logo" className={`${styles.navBarLogo}`} />

        <div className={`${styles.buttonsContainer}`}>
          {getUserToken() !== null && (
            <button
              className={`${styles.logoutButton} btn btn-lg`}
              onClick={() => {
                userLogout();
                window.location.reload();
              }}
            >
              Log Out
            </button>
          )}

          <DarkModeSwitch sx={{ m: 1 }} onChange={toggleNightMode} checked={theme === 'dark' ? true : false} />
        </div>
      </nav>
    </>
  );
};

NavBar.propTypes = {
  theme: PropTypes.string.isRequired,
  toggleNightMode: PropTypes.func
};

export default NavBar;
